import { Injectable, Component, NgModule, ViewEncapsulation } from '@angular/core';
import {MatSnackBarModule, MatSnackBar} from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';

@Injectable()
export class ToasterService {
    private message: string;
    private flag: string;

    constructor(private snackBar: MatSnackBar) { }

    showToaster(flag: string, msg: string) {
        if (msg === 'token_not_provided') {
            msg = '로그인 후 이용해 주세요';
        }

        this.flag = flag;
        this.toasterMessage = msg;
        const snackBarRef = this.snackBar.openFromComponent(ToasterComponent, {
                  duration: 3000, // 3000
        });

        snackBarRef.afterDismissed().subscribe(() => {
           // console.log('The snack-bar was dismissed');
        });


        snackBarRef.onAction().subscribe(() => {
          // console.log('The snack-bar action was triggered!');
        });
    }

    set toasterMessage(message: string) {
        this.message = message;
    }

    get getToasterMessage(): string {
        return this.message;
    }

    set toasterFlag(flag: string) {
        this.flag = flag;

    }

    get getToasterFlag(): string {
        return this.flag;
    }
}

@Component({
  template: `<div [innerHTML]="toasterMessage"
                    [ngClass]="{'toaster-box-info': toasterFlag === 'info', 'toaster-box-error': toasterFlag === 'error'}">
            </div>`
  , styles: [
      '.mat-snack-bar-container {max-width: 100%}',
      '.toaster-box-info {padding: 14px 24px;background-color: #1992e4;color: #fff; text-align: center;}',
      '.toaster-box-error {padding: 14px 24px;background-color: #e74545;color: #fff; text-align: center;}'
  ],
  encapsulation: ViewEncapsulation.None
})
// #1992e4
export class ToasterComponent {
    toasterMessage: string;
    toasterFlag: string;
    constructor(
        private toasterService: ToasterService
    ) {
        this.toasterMessage = this.toasterService.getToasterMessage;
        this.toasterFlag = this.toasterService.getToasterFlag;
    }
}

@NgModule({
    declarations: [
        ToasterComponent
    ],
    imports: [CommonModule, MatSnackBarModule],
    exports: [ ToasterComponent ],
    providers: [ToasterService],

    entryComponents: [ ToasterComponent ],
})
export class ToasterModule { }
